module.exports = __webpack_public_path__ + "static/img/default_avartar_boy@2x.c69d15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar/default_avartar_boy@2x.png
// module id = mZa5
// module chunks = 33 34